// Shared UI-language switch. Used by the marketing header's
// LanguageSwitcher and the in-app avatar/account menu so both flip the
// locale the same way: update svelte-i18n immediately (in-tab, no
// Inertia visit — keeps a live voice session intact) and persist the
// choice server-side via PATCH /locale (signed cookie + user column +
// cable broadcast, handled by LocalesController).
import { locale as i18nLocale } from "svelte-i18n"

import { csrfToken } from "@/lib/csrf"
import { rememberLanguageChoice } from "@/lib/language-suggestion"

// `persist` must be one of the base language codes — LocalesController
// validates against I18n.available_locales and silently no-ops otherwise.
// `display` defaults to `persist` but can be a region code (e.g. "de-CH")
// so the language switcher can flip the in-tab dictionary straight to the
// merged one (already registered by lib/i18n.ts) while still persisting
// only the base language server-side.
export async function setLocale(
  persist: string,
  display: string = persist,
): Promise<void> {
  // An explicit pick also silences the marketing pages' language-suggestion
  // banner — the signed cookie below is httponly, so the banner relies on
  // this localStorage record to know a choice was made.
  rememberLanguageChoice(persist)
  i18nLocale.set(display)
  const form = new FormData()
  form.append("locale", persist)
  await fetch("/locale", {
    method: "PATCH",
    headers: { "X-CSRF-Token": csrfToken(), Accept: "application/json" },
    body: form,
    credentials: "same-origin",
  })
}
